import Box from "@mui/material/Box";
import React from "react";
import { BingoResolution, getTitleToDisplay } from "./BingoResolution";
import { isLightColor } from "./ColorPicker";

interface BingoSquareProps {
  bingoResolution: BingoResolution;
  onClick: () => void;
}

export default function BingoSquare({
  bingoResolution,
  onClick,
}: BingoSquareProps) {
  const hasReachedGoal =
    bingoResolution.currentTally >= bingoResolution.goalTally &&
    bingoResolution.goalTally > 0;

  return (
    <Box
      border={1}
      borderRadius={2}
      textAlign="center"
      className={`cursor-pointer flex flex-col justify-between h-full ${
        hasReachedGoal ? "bg-green-200 font-bold" : ""
      }`}
      style={
        hasReachedGoal
          ? undefined
          : {
              backgroundColor: bingoResolution.color,
              color: isLightColor(bingoResolution.color) ? "black" : "white",
            }
      }
      onClick={onClick}
    >
      <Box className="sm:text-xl">
        {getTitleToDisplay(bingoResolution.title)}
      </Box>

      <Box className="text-xl">
        {bingoResolution.currentTally}/{bingoResolution.goalTally}{" "}
        {hasReachedGoal ? "✅" : ""}
      </Box>
    </Box>
  );
}
